export const CATEGORY_BANNER = "category";
export const BRAND_BANNER = "brand";
